<template>
  <div class="regional-offices">
    <div class="container">
      <div :class="['row', 'key-contact', sub_class]" v-if="title">
        <div class="col-l-4 col-m-4 col-s-12">
          <div class="our-location__label" v-if="title">{{ title }}</div>
          <div class="location-list">
            <ul>
              <li
                class="location-list__item"
                :class="{ 'location-list__item--active': activeOffice === i }"
                v-for="(office, i) in offices"
                :key="i"
                @click="setActiveOffice(i, office.city_slug)"
              >
                <span class="location-list__item-text">{{
                  office && office.city
                }}</span>
                <span
                  v-if="activeOffice === i"
                  class="location-list__item-arrow"
                ></span>
              </li>
            </ul>
            <div>
              <div v-if="offices" v-for="(office, i) in offices">
                <p class="annotation" v-if="activeOffice === i">
                  {{ office && office.annotation }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="offices[this.activeOffice]"
          class="location-details col-l-4 col-m-4 col-s-12"
        >
          <div
            class="our-location__adress"
            v-if="offices[this.activeOffice]"
            v-html="offices[this.activeOffice].adress"
          ></div>
          <div
            class="our-location__button"
            v-if="
              offices[this.activeOffice] &&
              !offices[this.activeOffice].button_adress_display
            "
          >
            <router-link
              active-class="active"
              :to="'/' + slug + '/' + offices[this.activeOffice].city_slug"
            >
              <div class="btn default">
                <span
                  class="our-location__button-text"
                  v-html="offices[this.activeOffice].button_adress_label"
                ></span>
                <span class="our-location__button-arrow"></span>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-l-4 col-m-4 col-s-12 our-location__map">
          <iframe
            v-if="offices[activeOffice] && offices[activeOffice].map_link"
            :src="offices[activeOffice].map_link"
            width="100%"
            height="340"
            frameborder="0"
            allowfullscreen="allowfullscreen"
          ></iframe>
        </div>
      </div>

      <div v-else>
        <div class="be-contact-map">
          <div class="container">
            <div class="row mb-50">
              <div class="col-l-4 col-m-4 col-s-12">
                <div class="location location-info">
                  <h2
                    class="location-info__title"
                    v-if="bedata.title"
                    v-html="bedata.title"
                  ></h2>
                  <div
                    class="location-info__adress"
                    v-if="bedata.adress"
                    v-html="bedata.adress"
                  ></div>
                </div>
              </div>
              <div class="col-l-4 col-m-4 col-s-12">
                <div class="location location-person">
                  <div class="location-person__image">
                    <img
                      v-if="bedata.photo"
                      :src="bedata.photo.url"
                      alt="photo"
                    />
                  </div>
                  <div class="location-person__info">
                    <div class="location-person__name">{{ bedata.name }}</div>
                    <div class="location-person__position">
                      {{ bedata.position }}
                    </div>
                    <div class="location-person__email">
                      <a :href="'mailto:' + bedata.email">{{ bedata.email }}</a>
                    </div>
                    <div class="location-person__phone">
                      <a :href="'tel:' + bedata.phone">{{ bedata.phone }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-l-4 col-m-4 col-s-12">
                <div class="location location-map">
                  <iframe
                    class="location-map__iframe"
                    style="border: 0"
                    :src="bedata.map_link"
                    width="100%"
                    height="340"
                    frameborder="0"
                    allowfullscreen="allowfullscreen"
                  ></iframe>
                </div>
              </div>
            </div>

            <div>
              <div class="form-wrapper" v-html="bedata.contact_form"></div>
            </div>
          </div>
        </div>
      </div>

      <template v-for="(block, index) in blocks">
        <component
          :is="block.acf_fc_layout"
          :key="index"
          :blockdata="block"
          :city_title="city_title"
          :cities="cities"
        ></component>
      </template>
    </div>
  </div>
</template>

<script>
import BlockOtherRegions from "../components/BlockOtherRegions.vue";
import BlockCmgGreenhouse from "../components/BlockCmgGreenhouse.vue";
import Block from "../components/Block.vue";
import AfricaNetwork from "../components/AfricaNetwork.vue";
import MenaContactMap from "../components/MenaContactMap.vue";

export default {
  name: "regional-offices",
  data() {
    return {
      offices: [],
      cities: [],
      title: 0,
      city_title: undefined,
      activeOffice: 0,
      blocks: 0,
      bedata: undefined,
      sub_class: 0,
    };
  },
  components: {
    BlockOtherRegions,
    BlockCmgGreenhouse,
    Block,
    AfricaNetwork,
    MenaContactMap,
  },
  created: function () {
    this.$root.dataReady = false;
  },
  mounted: function () {
    this.fetchContactMap();
  },
  props: ["slug"],
  methods: {
    fetchContactMap: function () {
      var self = this;

      $.get(
        this.$root.apiUrl + "wp-json/wp/v2/pages?slug=" + self.slug,
        function (response) {
          self.offices = response[0].acf.block_grid[0]["maps-repeater"];
          self.cities = response[0].acf.block_grid[1]["location-repeater"];
          self.title = response[0].acf.block_grid[0].title;
          self.sub_class = response[0].acf.block_grid[0].class;
          self.city_title = response[0].acf.block_grid[1].title;
          self.bedata = response[0].acf.block_grid[1];
          self.$root.dataReady = true;
          self.blocks = response[0].acf.block_grid;
        }
      )
        .done(function () {})
        .fail(function () {});
    },
    setActiveOffice(officeIndex) {
      this.activeOffice = officeIndex;
    },
  },
};
</script>



// WEBPACK FOOTER //
// RegionalOffices.vue?57824026